import addError from '../../../utils/error.jsx';
import { bulk } from './update';

export function request(sport, list, displayFields) {
    return {
        type: 'SPORTS_LIST_MOVE_REQUEST',        
        sport,
        list
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'SPORTS_LIST_MOVE_ERROR',
        errors
    };
}

export function finish(sports) {   
    return (dispatch) => {
        dispatch(bulk(sports));
        
        dispatch({
            type: 'SPORTS_LIST_MOVE_FINISH',
            sports
        });
    };
}
